import { render } from "./UserPicker.vue?vue&type=template&id=f1aeb864&scoped=true"
import script from "./UserPicker.vue?vue&type=script&lang=js"
export * from "./UserPicker.vue?vue&type=script&lang=js"

import "./UserPicker.vue?vue&type=style&index=0&id=f1aeb864&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1aeb864"]])

export default __exports__